import authorize from "@Images/NewUI/magnifyglassAstronew.png";
import secure from "@Images/NewUI/securehere.png";
import "@Styles/mandate.css";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  payme_bank_list,
  payme_manual_verification_description,
  payme_manual_verification_heading
} from "../../../../src/helper/modalConstant";
import ModalBox from "../../../helper/modalBox";
import { HEADING_MANUALVERIFICATION } from "../Common/constant";
import arrowleft from "@Images/NewUI/Vector.png";
import { getUserDetail } from "../../../Redux/GeneralDetails/action";
import { getDocumentStatus, getWebViewEkycUrl } from "../../../Redux/Manual_Kyc_Details/action";
import { withRouter } from "../../../hooks/withRouter";
import { trackKycAadhaarVerified } from "../../../utils/ga4";


const ManualVerify = (props) => {
  const navigate = useNavigate();
  const [modalState, setModalState] = useState(false);
  let token = props?.user?.User?.token || localStorage.getItem("gpay_token");

  const [eVerifyBtn, setVerifyBtn] = useState(true);
  const [mVerifyBtn, setMverifyBtn] = useState(false);
  const [eKycUrl, seteKycUrl] = useState("");
  const [loader, setLoader] = useState(false);

  let querypram = new URLSearchParams(window.location.search).get("keyfrom");
  const [keyfrom, setKeyfrom] = useState(querypram);

  const getDocs = (token) => {
    props.getDocumentStatus(token).then((res) => {
      res.data.map((details) => {
        if (details.kyc_verified == "VERIFIED") {
          trackKycAadhaarVerified();
          if (!details.can_apply_for_loan) {
            navigate("/kycprofileinreview");
            return;
          }
          if (keyfrom === "apply_now") {
            navigate("/key-statements");
            return;
          }
          navigate("/dashboard_s");
        }
      });
    });
  };

  useEffect(() => {
    let token = props?.user?.User?.token || localStorage.getItem("gpay_token");
    let ekycweburl = "";

    props.getWebViewEkycUrl(token).then((res) => {
      seteKycUrl(res.url);
      ekycweburl = res.url;
    });

    props.getDocumentStatus(token).then((res) => {
      res.data.map((details) => {
        if (keyfrom !== "kycchange") {
          if (details.kyc_verified == "PENDING_VERIFICATION") {
            navigate("/kycverifyinprogress");
            return;
          }
          if (details.kyc_verified == "NOT_VALID") {
            navigate("/kycnotdone");
            return;
          }
          if (details.kyc_verified == "VERIFIED") {
            if (!details.can_apply_for_loan) {
              navigate("/kycprofileinreview");
              return;
            }
            if (keyfrom === "apply_now") {
              navigate("/key-statements");
              return;
            }
            navigate("/dashboard_s");
            return;
          }
        }

        if (details.kyc_verified == "NOT_SUBMITTED") {
          setTimeout(() => {
            window.open(ekycweburl, "_blank");
          }, 100);
        }
      });
    });

    const interval = setInterval(() => {
      getDocs(token);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const handleclose = () => {
    navigate("/complete_your_profile");
  };

  const openUrl = () => {
    window.open(eKycUrl, "_blank");
  };

  return (
    <>
      <div className="customheading-manverify sticky-header d-flex shadowline align-items-center">
        <img
          className="kycheadinghere"
          src={arrowleft}
          onClick={() => navigate(-1)}
        />
        <h1
          className="boldheading"
          style={{ paddingLeft: "10px", color: "#152745", fontWeight: "700", fontSize: "26px" }}
        >
          {HEADING_MANUALVERIFICATION}
        </h1>
      </div>

      <div id="dashboardbackground" className="main_div toolbarRespo">

        <div className="wrapper-content e-sign container kyc-failed-wrap">
          <div className="kyc-failed-card">

            <img
              src={authorize}
              alt="KYC Failed"
              className="kyc-failed-illustration"
            />

            <h3 className="kyc-failed-title">
              We couldn’t verify your details earlier.
            </h3>

            <p className="kyc-failed-subtitle">
              To continue your loan application, please complete KYC
            </p>

          </div>
        </div>

        <div className="bg--white">
  <div className="text-center stickeybottomsignnew" style={{ marginBottom: "30px" }}>
    
    <button
      onClick={openUrl}
      className="bg-orange text-white newbtnDesignsign font700 py-6"
    >
      Try Again
    </button>

    <div className="kyc-secure-wrapper">
      <img
        src={secure}
        alt="Secure"
        className="kyc-secure-img"
      />
    </div>

  </div>
</div>


      </div>

      {modalState && (
        <ModalBox
          modalType={"description"}
          description={payme_manual_verification_description}
          heading={payme_manual_verification_heading}
          List={payme_bank_list}
          open={true}
          onChange={(props) => setModalState(props)}
          imagesVisible={true}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default withRouter(connect(mapStateToProps, {
  getWebViewEkycUrl,
  getUserDetail,
  getDocumentStatus,
})(ManualVerify));

